import { DateTimeUtil } from "@neumetric/blueprint-lib/utility";

const VARIABLES = [
  { variable: "[[OrgnName]]", scope: "console" },
  { variable: "[[OrgnFullname]]", scope: "console" },
  { variable: "[[OrgnLogo]]", scope: "console" },
  { variable: "[[OrgnNameAPST]]", scope: "console" },
  { variable: "[[OrgnWebsite]]", scope: "console" },
  { variable: "[[OrgnInfosecEmail]]", scope: "console" },
  { variable: "[[OrgnLocnCity]]", scope: "console" },
  { variable: "[[OrgnAddress]]", scope: "console" },

  { variable: "[[OrgnDescription]]", scope: "blank" },
  { variable: "[[OrgnServices]]", scope: "blank" },
  { variable: "[[OrgnVisionStatement]]", scope: "blank" },
  { variable: "[[OrgnMissionStatement]]", scope: "blank" },
  { variable: "[[AuditScope]]", scope: "blank" },
  { variable: "[[AuditStartDate]]", scope: "audit" },
  { variable: "[[AuditEndDate]]", scope: "audit" },
  { variable: "[[DcmtTitle]]", scope: "blank" },
  { variable: "[[DcmtStatus]]", scope: "blank" },
  { variable: "[[DcmtSeqNum]]", scope: "blank" },
  { variable: "[[DcmtFilename]]", scope: "blank" },
  { variable: "[[ReportID]]", scope: "report" },
  { variable: "[[ReportDate]]", scope: "report" },
  { variable: "[[CPAFullName]]", scope: "blank" },
  { variable: "[[CPAMembershipNumber]]", scope: "blank" },
  { variable: "[[CPAMembershipState]]", scope: "blank" },

  { variable: "[[AuditTSC]]", scope: "static" },
  { variable: "[[AuditTSCList]]", scope: "static" },
];

const CONTROL_CATEGORIES = [
  { prefix: "CC", title: "Security" },
  { prefix: "C", title: "Confidentiality" },
  { prefix: "A", title: "Availability" },
  { prefix: "PI", title: "Processing Integrity" },
  { prefix: "P", title: "Privacy" },
];

const VARIABLES_CONTROL_LIST = "[[AdtCntrlLst]]";
const VARIABLES_EXP_CONTROL_LIST = "[[AdtExptsCntrlLst]]";
const VARIABLE_TOC = "[[TableOfContents]]";

const getPrimaryEmailAddress = (org) => {
  let email = org.email_domain.split(",")[0];
  if (email) {
    email = email.replace("@", "");
  }
  return email;
};
const getConsoleVariableValue = (org, variable) => {
  let varHTML = "",
    val,
    addS;
  switch (variable) {
    case "[[OrgnName]]":
      varHTML = org.brandname;
      break;
    case "[[OrgnNameAPST]]":
      val = String(org.brandname);
      addS =
        val.endsWith("s") ||
        val.endsWith("se") ||
        val.endsWith("sh") ||
        val.endsWith("ce");
      val += "'";
      if (!addS) {
        val += "s";
      }
      varHTML = val;
      break;
    case "[[OrgnFullname]]":
      val = String(org.legalname);
      val = val.replace("pvt", "Private");
      val = val.replace("ltd", "Limited");
      // varHTML = `<span style="text-transform: capitalize">${val}</span>`;
      varHTML = val;
      break;
    case "[[OrgnDomain]]":
      val = String(getPrimaryEmailAddress(org)).toLowerCase();
      varHTML = `${val}`;
      break;
    case "[[OrgnWebsite]]":
      val = org.website;
      varHTML = `<a href="${val}" style="text-decoration:none">${val}</a>`;
      break;
    case "[[OrgnInfosecEmail]]":
      varHTML = org.infosec_email;
      break;
    case "[[OrgnAddress]]":
      varHTML = org.facility.registered_address;
      break;
    case "[[OrgnLocnCity]]":
      varHTML = org.facility.city;
      break;
    default:
      varHTML = variable;
  }
  return varHTML;
};

const getAuditVariableValues = (audit, variable) => {
  if (!audit) {
    return "";
  }
  let varHTML = "";
  switch (variable) {
    case "[[AuditStartDate]]":
      varHTML = audit && audit.actual_start_date;
      varHTML = varHTML
        ? new DateTimeUtil(varHTML).toString("ddd, DD-MMM-YYYY")
        : "";
      break;
    case "[[AuditEndDate]]":
      varHTML = audit && audit.actual_end_date;
      varHTML = varHTML
        ? new DateTimeUtil(varHTML).toString("ddd, DD-MMM-YYYY")
        : "";
      break;
    default:
      break;
  }
  return varHTML;
};

const getReportVariableValues = (report, variable) => {
  if (!report) {
    return "";
  }
  let varHTML = "";
  switch (variable) {
    case "[[ReportDate]]":
      varHTML = report && report.reportdate;
      varHTML = varHTML
        ? new DateTimeUtil(varHTML).toString("ddd, DD-MMM-YYYY")
        : "";
      break;
    case "[[ReportID]]":
      varHTML = (report && report.report_id) || "";
      break;
    default:
      break;
  }
  return varHTML;
};

const getStaticVariableMapping = (variable) => {
  let varHTML = "";
  const TSCValue =
    "Security, Confidentiality, Processing Integrity, Availability & Privacy";
  switch (variable) {
    case "[[AuditTSC]]":
      varHTML = TSCValue;
      break;
    case "[[AuditTSCList]]":
      varHTML = TSCValue.split(",")
        .map((txt) => String(txt).trim())
        .join("<br/>");
      break;
    default:
      varHTML = variable;
      break;
  }
  return varHTML;
};

export const getControlTablesPageNo = (pageContents) => {
  let controlTablePageNo = null,
    tocPages = [],
    expControlTablePageNo = null;
  for (let pageIndex = 0; pageIndex < pageContents.length; pageIndex++) {
    const contentCopy = String(pageContents[pageIndex]);
    if (
      controlTablePageNo === null &&
      contentCopy.includes(VARIABLES_CONTROL_LIST)
    ) {
      controlTablePageNo = pageIndex;
    }
    if (
      expControlTablePageNo === null &&
      contentCopy.includes(VARIABLES_EXP_CONTROL_LIST)
    ) {
      expControlTablePageNo = pageIndex;
    }
    if (
      contentCopy.includes(VARIABLE_TOC) &&
      tocPages.indexOf(pageIndex) === -1
    ) {
      tocPages.push(pageIndex);
    }
  }
  return { controlTablePageNo, tocPages, expControlTablePageNo };
};
export const performVariableMapping = (org, audit, report, pageContents) => {
  const newContents = [];
  pageContents.forEach((pageContent, pageIndex) => {
    let contentCopy = String(pageContent);
    VARIABLES.forEach(({ variable, scope }) => {
      let value = "";
      switch (scope) {
        case "console":
          value = getConsoleVariableValue(org, variable);
          break;
        case "static":
          value = getStaticVariableMapping(variable);
          break;
        case "audit":
          value = getAuditVariableValues(audit, variable);
          break;
        case "report":
          value = getReportVariableValues(report, variable);
          break;
        case "blank":
          value = "";
          break;
        default:
          value = variable;
          break;
      }
      contentCopy = contentCopy.replaceAll(variable, value ?? "");
    });
    newContents[pageIndex] = contentCopy;
  });
  return newContents;
};
export const getExceptionTablePageNo = (pageContents) => {
  let expControlTablePageNo = -1;
  for (let i = pageContents.length - 1; i >= 0; i--) {
    const pageContent = pageContents[i];
    if (pageContent.includes(VARIABLES_EXP_CONTROL_LIST)) {
      expControlTablePageNo = i;
      break;
    }
  }
  return expControlTablePageNo;
};
export const createControlTable = () => {
  const table = document.createElement("table");

  table.className = "audit-control-table";
  table.style.width = "100%";
  table.style.borderCollapse = "collapse";

  table.innerHTML = `
    <thead>
      <tr>
        <th style="width:10%" class="white-right-border">Ref. No</th>
        <th style="width:40%" class="white-right-border">Control Description and Design</th>
        <th style="width:30%" class="white-right-border">Testing the Design of Controls</th>
        <th style="width:20%">Test Result</th>
      </tr>
    </thead>
    <tbody></tbody>
  `;
  return table;
};

export const createExeptionControlTable = () => {
  const table = document.createElement("table");

  table.className = "audit-exp-control-table";
  table.style.width = "100%";
  table.style.borderCollapse = "collapse";

  table.innerHTML = `
    <thead>
      <tr>
        <th style="width:10%" class="white-right-border">Ref. No</th>
        <th style="width:40%" class="white-right-border">Control Description and Design</th>
        <th style="width:25%" class="white-right-border">Exception Noted</th>
        <th style="width:25%">Management Response</th>
      </tr>
    </thead>
    <tbody></tbody>
  `;
  return table;
};

const insertRowToTable = (table, row) => {
  const tableBody = table.querySelector("tbody");
  tableBody.appendChild(row);
};

export const createControlRow = (control) => {
  const row = document.createElement("tr");
  row.setAttribute("data-row-type", "control");
  row.setAttribute("data-control-id", control.id);
  row.innerHTML = `
    <td class="control-cell">
      <div class="cell-content">
        ${control.title || ""}
      </div>
    </td>
    <td class="control-cell">
      <div class="cell-content">
        ${control.desc || ""}
      </div>
    </td>
    <td class="control-cell">
      <div class="cell-content">
      ${control.assessor_observation || ""}
      </div>
    </td>
    <td class="control-cell"> 
      <div class="cell-content">
      ${control.result_value || ""}
      </div>
    </td>
  `;
  return row;
};

export const createExeptionControlRow = (control) => {
  const row = document.createElement("tr");
  row.setAttribute("data-row-type", "control");
  row.setAttribute("data-control-id", control.id);
  row.innerHTML = `
    <td class="control-cell">
      <div class="cell-content">
        ${control.title || ""}
      </div>
    </td>
    <td class="control-cell">
      <div class="cell-content">
        ${control.desc || ""}
      </div>
    </td>
    <td class="control-cell">
      <div class="cell-content">
      ${control.assessor_observation || ""}
      </div>
    </td>
    <td class="control-cell"> 
      <div class="cell-content">
      
      </div>
    </td>
  `;
  return row;
};

export const createControlSectionRow = (section) => {
  const id = section.title.split(":")[0];
  const title = section.title.split(":")[1];
  const row = document.createElement("tr");
  row.className = "section-row";
  row.setAttribute("data-row-type", "control-section");
  row.innerHTML = `
    <td>
      <div class="cell-content control-section-cell"><strong>${id}</strong></div>
    </td>
    <td colspan="3">
      <div class="cell-content control-section-cell"><strong>${title}</strong>: ${section.desc}</div>
    </td>
  `;
  return row;
};

export const createControlGroupRow = (group) => {
  const { title } = group;
  const [id, desc] = title.split(":");
  const row = document.createElement("tr");
  row.className = "section-row";
  row.setAttribute("data-row-type", "control-group");
  row.innerHTML = `
    <td>
      <div class="cell-content control-group-cell"><strong>${id}</strong></div>
    </td>
    <td colspan="3">
      <div class="cell-content control-group-cell"><strong>${desc}</strong></div>
    </td>
  `;
  return row;
};

export const createCategoryRow = (category) => {
  const row = document.createElement("tr");
  row.className = "section-row";
  row.setAttribute("data-row-type", "group");
  row.innerHTML = `
    <td colspan="4">
      <div class="cell-content control-catergory-cell"><strong>Criteria for ${category}</strong></div>
    </td>
  `;
  return row;
};

export const createEmptyDataRow = () => {
  const row = document.createElement("tr");
  row.className = "empty-row";
  row.setAttribute("data-row-type", "empty");
  row.innerHTML = `
    <td colspan="4">
      <div class="cell-content control-empty-cell"><strong>No Rows</strong></div>
    </td>
  `;
  return row;
};

export const getControlCategory = (control) => {
  const { title } = control;
  const group = CONTROL_CATEGORIES.find((category) =>
    title.startsWith(category.prefix),
  );
  return group ? group.title : null;
};

export const getPageContainer = (iPageNo) => {
  let currentPage = document.querySelector(`#page-${iPageNo + 1}`);
  return currentPage.querySelector(".ck-container");
};

export const generateControlPages = async (iOptions) => {
  const option = iOptions || {};
  const { controls, startingPagNo, emptyPageNo } = option;
  let currentPageNo = startingPagNo;
  let container = getPageContainer(currentPageNo);
  const placeHolder = [...container.querySelectorAll("*")]
    .filter((el) => el.children.length === 0) // no element children = leaf
    .find((el) => el.textContent.trim() === VARIABLES_CONTROL_LIST);

  const pageHeight = 850;
  let currentTable = createControlTable();
  if (placeHolder) {
    placeHolder.replaceWith(currentTable);
  }
  let currentGroup, currentSection, currentCategory;
  const newPages = [];
  const controlsToInclude = controls.filter(({ report_findings }) => {
    return Boolean(report_findings);
  });
  if (controlsToInclude.length > 0) {
    const { section, group } = controlsToInclude[0];
    currentCategory = getControlCategory(controlsToInclude[0]);
    const categoryRow = createCategoryRow(currentCategory);
    insertRowToTable(currentTable, categoryRow);
    const groupRow = createControlGroupRow(group);
    insertRowToTable(currentTable, groupRow);
    currentGroup = group.id;
    const sectionRow = createControlSectionRow(section);
    insertRowToTable(currentTable, sectionRow);
    currentSection = section.id;
    for (let i = 0; i < controlsToInclude.length; i++) {
      const control = controlsToInclude[i];
      const { group, section } = control;
      const category = getControlCategory(control);
      const rowsToInsert = [];
      if (category !== currentCategory) {
        currentCategory = category;
        const categoryRow = createCategoryRow(currentCategory);
        rowsToInsert.push(categoryRow);
      }
      if (group.id !== currentGroup) {
        currentGroup = group.id;
        const groupRow = createControlGroupRow(group);
        rowsToInsert.push(groupRow);
      }
      if (section.id !== currentSection) {
        currentSection = section.id;
        const sectionRow = createControlSectionRow(section);
        rowsToInsert.push(sectionRow);
      }
      const controlRow = createControlRow(control);
      rowsToInsert.push(controlRow);
      for (let j = 0; j < rowsToInsert.length; j++) {
        const rowDom = rowsToInsert[j];
        insertRowToTable(currentTable, rowDom);
        if (container.clientHeight > pageHeight) {
          newPages.push(container.innerHTML);
          if (currentPageNo === startingPagNo) {
            container = getPageContainer(emptyPageNo);
            container.innerHTML = "";
            currentPageNo = emptyPageNo;
          } else if (currentPageNo === emptyPageNo) {
            container.innerHTML = "";
          }
          currentTable = createControlTable();
          container.appendChild(currentTable);
        }
      }
    }
    newPages.push(container.innerHTML);
  }
  return newPages;
};
export const generateExceptionControlPages = (iOptions) => {
  const option = iOptions || {};
  const { controls, startingPagNo, emptyPageNo } = option;
  let currentPageNo = startingPagNo;
  let container = getPageContainer(currentPageNo);
  const placeHolder = [...container.querySelectorAll("*")]
    .filter((el) => el.children.length === 0) // no element children = leaf
    .find((el) => el.textContent.trim() === VARIABLES_EXP_CONTROL_LIST);
  const pageHeight = 850;
  let currentTable = createExeptionControlTable();
  if (placeHolder) {
    placeHolder.replaceWith(currentTable);
  }
  const FailureResults = ["not compliant", "testing exception"];
  const filteredControls = controls.filter(
    ({ report_findings, result_value }) => {
      return (
        Boolean(report_findings) &&
        FailureResults.includes((result_value || "").toLowerCase())
      );
    },
  );
  const newPages = [];
  if (filteredControls.length > 0) {
    for (let i = 0; i < filteredControls.length; i++) {
      const control = controls[i];
      const controlRow = createExeptionControlRow(control);
      insertRowToTable(currentTable, controlRow);
      if (container.clientHeight > pageHeight) {
        newPages.push(container.innerHTML);
        if (currentPageNo === startingPagNo) {
          container = getPageContainer(emptyPageNo);
          container.innerHTML = "";
          currentPageNo = emptyPageNo;
        } else if (currentPageNo === emptyPageNo) {
          container.innerHTML = "";
        }
        currentTable = createExeptionControlTable();
        container.appendChild(currentTable);
      }
    }
  } else {
    const emptyRow = createEmptyDataRow();
    insertRowToTable(currentTable, emptyRow);
  }
  const eor = document.createElement("p");
  eor.style.fontSize = "14px";
  eor.style.fontWeight = "bold";
  eor.style.fontStyle = "italic";
  eor.style.textAlign = "center";
  eor.textContent = "- End of SOC 2 Type 2 Report -";
  if (container) {
    container.appendChild(eor);
  }
  newPages.push(container.innerHTML);
  return newPages;
};

export const waitForAllPagesRendered = (container, expectedCount) => {
  return new Promise((resolve, reject) => {
    const maxWait = 60000; // 60s timeout safety net
    const interval = 500;
    let elapsed = 0;
    const timer = setInterval(() => {
      const rendered = container.querySelectorAll(".nm-report-page").length;
      if (rendered >= expectedCount) {
        clearInterval(timer);
        setTimeout(resolve, 1000);
      }
      elapsed += interval;
      if (elapsed >= maxWait) {
        clearInterval(timer);
        reject(
          new Error(
            `Timed out: only ${rendered}/${expectedCount} pages rendered`,
          ),
        );
      }
    }, interval);
  });
};
export const inlineImages = async (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const imgs = Array.from(doc.querySelectorAll("img"));

  await Promise.all(
    imgs.map(async (img) => {
      try {
        const res = await fetch(img.src);
        const blob = await res.blob();
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
        img.src = base64;
      } catch {
        console.warn("Could not inline image:", img.src);
      }
    }),
  );

  return doc.body.innerHTML;
};

export const extractCss = () => {
  return Array.from(document.styleSheets)
    .flatMap((sheet) => {
      try {
        return Array.from(sheet.cssRules).flatMap((rule) => {
          // Skip all @media rules entirely
          if (rule instanceof CSSMediaRule) return [];
          return [rule.cssText];
        });
      } catch {
        return [];
      }
    })
    .join("\n");
};
